/** @jsx jsx */
import { Fragment, h } from 'preact';

// Searchspring
import { getContext } from '@searchspring/snap-toolbox';

// Packages
import { jsx, css } from '@emotion/react';
import classnames from 'classnames';

// Local
import { fetchLocaleField } from '../../Helpers';

// CSS
import '../../Result/result.css';

export function CustomBundleProductCard({ cardProps: { parentProps, styling } }) {
	// Destructure relevant data from parent component props
	const { result, className, layout, controller } = parentProps;

	const core = result?.mappings?.core;
	const badge = fetchLocaleField(result, 'mfield_cql_badge', 'mfield_french_badge');
	const shortDescription = fetchLocaleField(result, 'mfield_cql_short_description');
	const discountSummary = fetchLocaleField(result, 'mfield_cql_discount_summary');

	// Handle fr product URL
	let productUrl = core.url;
	if (window.Shopify.locale == 'fr') {
		productUrl = `/fr${productUrl}`;
	}

	return (
		<article {...styling} className={classnames('ss__result', `ss__result--${layout}`, className)}>
			<a
				href={productUrl} //No variant selection on PLP, so extra logic not needed here.
				onMouseDown={(e) => {
					controller?.track?.product?.click(e, result);
				}}
				className="ss__result-link"
				aria-label={core.name}
			>
				<div className="product-card-top-wrapper">
					<div className="ss__result__image-wrapper">
						{badge && <div className="ss__badge ss__result__badge">{badge}</div>}
						<div {...styling} className={classnames('ss__image', 'ss__result__image', 'ss__result__image--custom-bundle')}>
							<img
								id={`ProductImage-${result.id}`}
								alt={core.name}
								class="product__img product__img--main lazyload"
								data-aspectratio="1.4967637540453074"
								data-sizes="auto"
								data-image
								src={core.imageUrl}
							/>
						</div>
					</div>
					<div className="ss__result__details ss__result__details__custom-bundle">
            <div className="ss__result__details__top_row ss__result__details__top_row-custom-bundle body-large"></div>
						<div className="ss__result__details__title body-medium">{core.name}</div>
						{shortDescription && <p className="custom-bundle-short-description">{shortDescription}</p>}
						{discountSummary && <p className="custom-bundle-discount-summary">{discountSummary}</p>}
					</div>
				</div>
			</a>
		</article>
	);
}
